import { Info } from '@phosphor-icons/react';

import {
  TooltipContent,
  TooltipProvider,
  TooltipRoot,
  TooltipTrigger,
} from '../ui/Tooltip';
import { cn } from '../../utils/cn';

/**
 * Tooltip educativo "Porquê?" reutilizado em toda a app.
 * Visualmente discreto, com bom contraste sobre fundo claro.
 */
export function InfoTooltip({ text, className, ariaLabel = 'Mais informação' }) {
  return (
    <TooltipProvider delayDuration={150}>
      <TooltipRoot>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label={ariaLabel}
            className={cn(
              'inline-flex h-5 w-5 items-center justify-center rounded-full text-muted-foreground/70 hover:text-sage-700 focus-visible:text-sage-700 focus-visible:outline-none',
              className,
            )}
          >
            <Info className="h-4 w-4" aria-hidden />
          </button>
        </TooltipTrigger>
        <TooltipContent>{text}</TooltipContent>
      </TooltipRoot>
    </TooltipProvider>
  );
}
